import { Link } from 'react-router-dom';

export default function PressHero() {
  return (
    <div className="relative w-full py-24 md:py-32" style={{ backgroundColor: '#f9f6f1' }}>
      <div className="flex flex-col items-center justify-center text-center px-6">
        <nav className="flex items-center gap-2 text-stone-500 text-xs font-sans mb-6">
          <Link to="/" className="hover:text-stone-800 transition-colors cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line" />
          <span className="text-stone-700">Press &amp; Contact</span>
        </nav>
        <p className="text-xs uppercase tracking-widest text-[#b89a6a] font-semibold mb-4 font-sans">
          MEDIA &amp; ENQUIRIES
        </p>
        <h1 className="font-serif text-4xl md:text-6xl font-bold text-gray-900 mb-4 leading-tight">
          Press &amp; Contact
        </h1>
        <p className="font-sans text-base text-gray-600 max-w-xl">
          Media coverage, press resources, and a direct line for interview requests, exhibition collaborations, and academic partnerships.
        </p>
      </div>
    </div>
  );
}